export default "__VITE_ASSET__u_Ipyv8k__"